module.exports = __webpack_public_path__ + "static/img/earningsReport.ca9de145.png";